import { render } from "./HangaIgnite.vue?vue&type=template&id=3c748990&scoped=true"
import script from "./HangaIgnite.vue?vue&type=script&lang=js"
export * from "./HangaIgnite.vue?vue&type=script&lang=js"

import "./HangaIgnite.vue?vue&type=style&index=0&id=3c748990&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c748990"]])

export default __exports__